import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProFleetInterface } from '../models/pro-fleet.interface';
import { LoginResponseInterface } from '../../authentication/models/login-response.interface';
import { ConstsHelper } from '../../../helpers/consts.helper';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class ProFleetService {

  constructor(private http: HttpClient) {}

  /**
   * Linked customers
   */
  getList(): Observable<Array<ProFleetInterface>> {
    const headers = { Authorization: 'Bearer ' + localStorage.getItem(ConstsHelper.LOCAL_STORAGE_ADMIN_PRO_FEET_TOKEN) };
    const splitHostname = window.location.hostname.split('.');
    let apiURL = environment.data.apiUrl;
    if (splitHostname.length > 0 && splitHostname[0].includes('extec')) {
      apiURL = environment.data.extEcApiUrl;
    }
    return this.http.get<Array<ProFleetInterface>>(apiURL + 'pro/fleet', { headers });
  }

  /**
   * Linked customer token
   */
  getToken(customerId: string): Observable<LoginResponseInterface> {
    const headers = { Authorization: 'Bearer ' + localStorage.getItem(ConstsHelper.LOCAL_STORAGE_ADMIN_PRO_FEET_TOKEN) };
    const splitHostname = window.location.hostname.split('.');
    let apiURL = environment.data.apiUrl;
    if (splitHostname.length > 0 && splitHostname[0].includes('extec')) {
      apiURL = environment.data.extEcApiUrl;
    }
    return this.http.get<LoginResponseInterface>(apiURL + 'pro/linked/customer/token/' + customerId, { headers });
  }
}
